"use strict";const s={defaultSnapshot:"/snapshot/",employeeSummary:"/snapshot/header/"};exports.ROUTES=s;
//# sourceMappingURL=constants-Diz_1eIW.js.map
